import { ApiClient } from './client';
import { ensureGuestToken } from './token-manager';

const PUBLIC_BASE_URL = 'https://' + import.meta.env.VITE_BACKEND_CUSTOM_DOMAIN_NAME + '/api-bf/';

const client = new ApiClient(PUBLIC_BASE_URL);

export const orderApi = {
  get: async <T>(endpoint: string) => {
    await ensureGuestToken();
    return client.get<T>(endpoint);
  },
  post: async <T>(endpoint: string, data?: unknown) => {
    await ensureGuestToken();
    return client.post<T>(endpoint, data);
  },
  put: async <T>(endpoint: string, data?: unknown) => {
    await ensureGuestToken();
    return client.put<T>(endpoint, data);
  },
  patch: async <T>(endpoint: string, data?: unknown) => {
    await ensureGuestToken();
    return client.patch<T>(endpoint, data);
  },
  delete: async <T>(endpoint: string) => {
    await ensureGuestToken();
    return client.delete<T>(endpoint);
  },
};